import React, { PureComponent } from 'react';
import { Wrapper } from './styles';
import * as THREE from 'three';
import * as dat from 'dat.gui';
import ReactDOM from 'react-dom';
import Renderer from '../../components/Renderer';
import { Sculpture, Spline } from '../../threejs/sculpture';
import UpdateLoop from '../../utils/UpdateLoop';
import OrbitControls from 'three-orbitcontrols';

export class App extends PureComponent {
	constructor() {
		super();
		this.ambientLight = new THREE.AmbientLight(0x0c0c0c);

		this.lights = [];
		this.lights[0] = new THREE.PointLight(0xffffff, 2, 700); //origin light
		//		this.lights[0].castShadow = true;
		this.lights[0].position.set(0, 0, 0);
		this.lights[0].power = 3;

		this.lights[1] = new THREE.PointLight(0xffffff, 1, 1000); //cam light
		//		this.lights[1].castShadow = true;
		this.lights[1].position.set(0, 0, 1000);

		this.lights[2] = new THREE.DirectionalLight(0xffffff, 0.3); //front light
		//		this.lights[2].castShadow = true;
		this.lights[2].position.set(0, 0, 1);

		this.lights[3] = new THREE.DirectionalLight(0xffffff, 0.9); //up light
		//		this.lights[3].castShadow = true;
		this.lights[3].position.set(0, 1, 0);

		this.spline = new Spline();
		this.sculpture = new Sculpture(this.spline);
		this.sculpture.position.y = -350;
	}

	componentWillUnmount() {
		this.gui.destroy();
	}

	componentDidMount() {
		this.controls = new OrbitControls(this.renderer.camera, ReactDOM.findDOMNode(this.renderer));

		UpdateLoop.add(this.controls);
		UpdateLoop.add(this.sculpture);

		//this.renderer.camera.rotation.x = -Math.PI*0.5;
		this.renderer.camera.position.z = 1000;


		this.gui = new dat.GUI();

		const sculpture = this.gui.addFolder('sculpture');

		this.gui.add(this.sculpture, 'angle', -6, 3);
		sculpture.add(this.sculpture, 'rotationCount', 0.1, 0.5);
		sculpture.add(this.sculpture, 'width', 0, 1);
		sculpture.add(this.sculpture, 'widthOsculation', 0.1, 0.5);
		sculpture.add(this.sculpture, 'speed', 0, 1);
		sculpture.open();

		const light = this.gui.addFolder('lights');
		light.add(this.lights[0], 'power', 0, 50);
		light.add(this.lights[1], 'power', 0, 50);
		light.add(this.lights[2], 'intensity', 0, 2);
		light.add(this.lights[3], 'intensity', 0, 2);

		light.open();
	}

	render() {
		const { ambientLight, sculpture, lights } = this;
		return (
			<Wrapper>
				<Renderer
					ref={input => {
						this.renderer = input;
					}}
					width={window.innerWidth}
					height={window.innerHeight}
					backgroundColor={0x000000}
				>
					{[ambientLight, sculpture, ...lights]}
				</Renderer>
			</Wrapper>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js